import React, { useEffect } from "react";

import { bem } from "EmployeeDashboard/utils";
import { useGetIndividualLifeApplicationQuery } from "IndividualLife/api";
import { IndividualLifeModal } from "IndividualLife/IndividualLifeModal";
import AnalyticsTracking from "Utils/AnalyticsTracking";

import { SubBody } from "Cobalt/BodyText";
import { useModal } from "Cobalt/Modal";
import BodyText from "Common/BodyText";
import { Card, CardSection } from "Common/Card";
import Header from "Cobalt/Header";
import { Div } from "Common/HTML";
import Button from "Theme/Button";

export interface IndividualLifeCardProps {
  adminMode: boolean;
  location: string;
  employeeForm: {};
}

const incompleteStatuses = ["application_incomplete", "application_incomplete_fallback_shown", "application_complete_action_needed"];
const pendingStatuses = ["application_complete_pending_underwriting", "offer_pending"];
const enrolledStatuses = ["covered"];

const SupplementalLine = ({ policyID, applicationStatus, location }) => {
  if (applicationStatus === "covered" && policyID) {
    return <BodyText>Policy ID: {policyID}</BodyText>;
  }
  return <BodyText>&nbsp;</BodyText>;
};

const ExistingApplicationDisplay = ({ data, openExistingApplication, location }) => {
  const applicationStatus = data.individualLifeApplication?.status;
  const policyID = data.individualLifePolicy?.policyID;
  let buttonText = "Continue Application";
  let callToAction = "Continue your life insurance application";

  if (incompleteStatuses.includes(applicationStatus)) {
    buttonText = "Continue Application";
    callToAction = "Continue your life insurance application";
  } else if (pendingStatuses.includes(applicationStatus)) {
    buttonText = "Review Application";
    callToAction = "Your life insurance application is pending";
  } else if (enrolledStatuses.includes(applicationStatus)) {
    buttonText = "View Coverage";
    callToAction = "You life insurance is active";
  }

  return (
    <Div>
      <Header level={7} mb={4}>Individual Term Life Insurance Policy</Header>
      <BodyText mt={4}>{callToAction}</BodyText>
      <SupplementalLine policyID={policyID} applicationStatus={applicationStatus} location={location} />
      <Button onClick={openExistingApplication} mt={4}>
        {buttonText}
      </Button>
    </Div>
  );
};

export const IndividualLifeCard = ({ adminMode, location, employeeForm }: IndividualLifeCardProps) => {
  const { isShowing, show, hide } = useModal();
  const { data, error } = useGetIndividualLifeApplicationQuery();

  useEffect(() => {
    AnalyticsTracking.trackEvent("individual_life_entrypoint_viewed", { role: "employee", location, adminMode });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const openExistingApplication = () => {
    window.open(data.linkToCarrierApplication, "_blank");
  };

  const buttonText = "Get Started";

  return (
    <Card p={4} ml={0}>
      <CardSection>
        {data && !error && data.individualLifeApplication && data.individualLifeApplication.status !== "initial_quote_created" ? (
          <ExistingApplicationDisplay data={data} openExistingApplication={openExistingApplication} location={location} />
        ) : (
          <Div>
            <IndividualLifeModal isShowing={isShowing} onHide={hide} employeeForm={employeeForm} />
            {location === "employee-dashboard" && (
              <Div className={bem("newTag")} mb={4}>
                🎉 New 🎉
              </Div>
            )}
            <Header level={7} mb={4}>Individual Term Life Insurance Policies</Header>
            <BodyText mt={4}>Now's the time for life insurance. Find out if you're instantly approved for coverage.</BodyText>
            <Button onClick={show} mt={4}>
              {buttonText}
            </Button>
            <SubBody pt={4} color="muted">
              By clicking &quot;{buttonText},&quot; you agree to SimplyInsured&apos;s Terms of Service and Privacy Policy.
            </SubBody>
          </Div>
        )}
      </CardSection>
    </Card>
  );
};
